import { IntervalObservable } from './IntervalObservable';
export var interval = IntervalObservable.create;
//# sourceMappingURL=interval.js.map